export const lobbyclearchoice = {
	PAGE_THEME_ENABLED: false,
};
